// Sauvegarder ProfileForm inputs

export function submitForm(values) {
    return {
        type: "save",
        values: values
    }
}

// Détecter le changement de pseudo

export function onChangeNickName(e) {
    return {
        type: "onchange",
        nickName: e.target.value
    }
}

// Détecter si la case "masquer mon age" est cochée ou non et cacher l'age dans profil

export function onChangeChecked(checkedValues) {
    return { type: "hideAge", hideAge: checkedValues.target.checked };
    }

export function onChangeDateOfBirth (moment) {
        return { type: "changedateofbirth", dateOfBirth: moment };
        }
